/* eslint-disable camelcase */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-param-reassign */
/* eslint-disable consistent-return */
/* eslint-disable eqeqeq */
/* eslint-disable no-plusplus */

window.cb_openlisting = function cb_openlisting(result) {
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'PanelId | undefined' is not assi... Remove this comment to see the full error message
  const pannel = window.xGetElementById(result.pannel_id);
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'HTMLElement | undefined' is not ... Remove this comment to see the full error message
  window.clearWorking(pannel);

  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  if (pannel.listing || pannel.view) {
    if (!window.breadcrumbs || window.breadcrumbs.length <= 0) {
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'HTMLElement | undefined' is not ... Remove this comment to see the full error message
      window.pushParent(pannel);
    } else {
      // Add listing to the breadcrumbs stack if it's not already there
      const lastParent = window.breadcrumbs[window.breadcrumbs.length - 1];
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      if (lastParent && lastParent.name !== result.ajax_listing.name) {
        // Need to set the type so that breadcrumbs works
        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        result.ajax_listing.type = 'listing';
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'AjaxListing | undefined' is not ... Remove this comment to see the full error message
        window.breadcrumbs.push(result.ajax_listing);
      }
    }
  } else {
    const parents = window.breadcrumbs;
    if (parents && parents.length == 1) {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      result.ajax_listing.type = 'listing';
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'AjaxListing | undefined' is not ... Remove this comment to see the full error message
      parents.push(result.ajax_listing);
    }
  }

  window.do_listingrefresh(result);
};
window.cb_refresh = function cb_refresh(result) {
  window.do_listingrefresh(result);
};

window.do_listingrefresh = function do_listingrefresh(result) {
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'PanelId | undefined' is not assi... Remove this comment to see the full error message
  let pannel = window.getListingPannel(result.pannel_id);
  // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
  $(pannel).addClass('is_pannel');
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'boolean | HTMLElement' is not as... Remove this comment to see the full error message
  window.clearWorking(pannel);

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'clear' does not exist on type 'Partial<{... Remove this comment to see the full error message
  if (result.clear) {
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'PanelId | undefined' is not assi... Remove this comment to see the full error message
    pannel = window.getListingPannel(result.pannel_id);
    if (!pannel) {
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'PanelId | undefined' is not assi... Remove this comment to see the full error message
      window.finishAjaxRequest(result.pannel_id, result);
      return;
    }
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'innerHTML' does not exist on type 'true ... Remove this comment to see the full error message
    pannel.innerHTML = '';
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'PanelId | undefined' is not assi... Remove this comment to see the full error message
    window.finishAjaxRequest(result.pannel_id, result);
    return;
  }

  if (!result.html || !pannel) {
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'PanelId | undefined' is not assi... Remove this comment to see the full error message
    window.finishAjaxRequest(result.pannel_id, result);
    return;
  }

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'current_type' does not exist on type 'tr... Remove this comment to see the full error message
  pannel.current_type = 'listing';
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
  pannel.listing = result.ajax_listing;
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing_row_values' does not exist on ty... Remove this comment to see the full error message
  pannel.listing_row_values = result.row_values;

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing_tabs_loaded' does not exist on t... Remove this comment to see the full error message
  if (!pannel.listing_tabs_loaded || !result.get_tab_only) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing_tabs_loaded' does not exist on t... Remove this comment to see the full error message
    pannel.listing_tabs_loaded = [];
  }
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing_tabs_loaded' does not exist on t... Remove this comment to see the full error message
  pannel.listing_tabs_loaded[pannel.listing.tab] = true;

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
  pannel.listing.deleted_rows = null;

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'get_tab_only' does not exist on type 'Pa... Remove this comment to see the full error message
  if (result.get_tab_only) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'id' does not exist on type 'true | HTMLE... Remove this comment to see the full error message
    const tab_pannel = window.xGetElementById(`${pannel.id}_${pannel.listing.tab}`);
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'id' does not exist on type 'true | HTMLE... Remove this comment to see the full error message
    const tab_select = window.xGetElementById(`${pannel.id}_${pannel.listing.tab}_select`);

    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    if (tab_pannel + tab_select) {
      // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
      $(tab_select).addClass('current_tab');
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      tab_pannel.innerHTML = result.html;
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      tab_pannel.style.display = '';

      // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing_tabs_loaded' does not exist on t... Remove this comment to see the full error message
      if (!pannel.listing_tabs_loaded) {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing_tabs_loaded' does not exist on t... Remove this comment to see the full error message
        pannel.listing_tabs_loaded = [];
      }
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing_tabs_loaded' does not exist on t... Remove this comment to see the full error message
      pannel.listing_tabs_loaded[result[2]] = true;
    }
  } else if (result.draw_all) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'parent_id' does not exist on type 'true ... Remove this comment to see the full error message
    if (!pannel.parent_id) {
      // setup listing keys, unless this is a listing inside of a view
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'id' does not exist on type 'true | HTMLE... Remove this comment to see the full error message
      window.subscribeListingKeys(pannel.id);
    }

    // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
    $(pannel).htmlReplace(result.html);

    // If pannel isn't visible then we're dealing with a top-level listing and
    // need to make #listing visible (and hide other top-level DOM objects).
    // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
    if ($(pannel).is(':hidden')) {
      // The panel can also be a listing inside a view, EX: Item > sales (listing all sales for item X)
      // In that case, the panel "reports_sales_listings_transaction_line_sales_view" is already visible
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'id' does not exist on type 'true | HTMLE... Remove this comment to see the full error message
      window.merchantos.page.show(pannel.id);
    }
  } else {
    // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'work_pannel'.
    work_pannel = window.xGetElementById(`work_${pannel.id}`);
    // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'work_pannel'.
    if (work_pannel) {
      // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'work_pannel'.
      work_pannel.innerHTML = result.html;
    }
  }

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing_link' does not exist on type 'Pa... Remove this comment to see the full error message
  if (result.listing_link) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'id' does not exist on type 'true | HTMLE... Remove this comment to see the full error message
    const listing_link = $(`#${pannel.id}_l_link`)[0];
    if (listing_link) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'href' does not exist on type 'HTMLElemen... Remove this comment to see the full error message
      listing_link.href = result.listing_link;
    }
  }

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
  pannel.listing.draw_all = false;
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
  pannel.listing.draw_tab_only = false;

  window.clearFieldChanges(pannel);

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'parent_id' does not exist on type 'true ... Remove this comment to see the full error message
  if (!pannel.parent_id) {
    window.setAutoFocus();
  }

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'expand_form' does not exist on type 'Par... Remove this comment to see the full error message
  if (result.expand_form) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'pannelExpando' does not exist on type 'W... Remove this comment to see the full error message
    window.pannelExpando(`expando_${pannel.id}`, `${pannel.id}_side_${result.expand_form}`);
  }

  // Listing loaded in a #listing page
  // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
  if (!$(pannel).closest('.view_listing').length) {
    $('body,html').scrollTop(0);
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'true | HTMLElement' is not assig... Remove this comment to see the full error message
    window.refreshPageHeader(pannel);
  } else {
    // Listing loaded in a #view page
    // Triggering an history change will mount/unmount react components.
    // This is added so components inside a view-listing are mounted as the html is injected.
    history.changeState();
  }

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
  if (pannel.listing.go_back) {
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    window.history.go(result.ajax_listing.go_back - 1);
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
    pannel.listing.go_back = false;
  }

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
  window.setPageSelector(pannel.listing);

  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'true | HTMLElement' is not assig... Remove this comment to see the full error message
  window.finishAjaxRequest(pannel, result);

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'refresh_helper' does not exist on type '... Remove this comment to see the full error message
  if (result.refresh_helper) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'refresh_helper' does not exist on type '... Remove this comment to see the full error message
    window.execRefreshHelper(result.refresh_helper, result.refresh_helper_args || []);
  }
};

/**
 * Calls a refresh helper for the listing.  The helper must be present
 * in the namespace.
 *
 * @param helper {String} The method to invoke
 * @param args {Array}  Arguments to pass to the refresh helper.
 */
window.execRefreshHelper = function execRefreshHelper(helper, args) {
  // traverse the namespace (if necessary) to retrieve
  // the function to call
  let helperFnc = window;
  // @ts-expect-error ts-migrate(7015) FIXME: Element implicitly has an 'any' type because index... Remove this comment to see the full error message
  // eslint-disable-next-line no-return-assign
  helper.split('.').forEach(object => (helperFnc = helperFnc[object]));

  if (typeof helperFnc === 'function') {
    // eslint-disable-next-line @typescript-eslint/ban-types
    (helperFnc as Function).apply(helperFnc, args);
  }
};

window.cb_openviewrecord = function cb_openviewrecord(result) {
  const pannel_id = 'view'; // ignore result['pannel_id']
  const pannel = window.getViewPannel(pannel_id);
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'HTMLElement | undefined' is not ... Remove this comment to see the full error message
  window.clearWorking(pannel);

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'success' does not exist on type 'Partial... Remove this comment to see the full error message
  if (!result.success || !pannel) {
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'PanelId | undefined' is not assi... Remove this comment to see the full error message
    window.finishAjaxRequest(result.pannel_id, result);
    return;
  }

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'new_stored_listing' does not exist on ty... Remove this comment to see the full error message
  if (pannel.new_stored_listing) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'new_stored_listing' does not exist on ty... Remove this comment to see the full error message
    pannel.stored_listing = pannel.new_stored_listing;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'new_stored_listing' does not exist on ty... Remove this comment to see the full error message
    pannel.new_stored_listing = false;
  }

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'view_tabs_loaded' does not exist on type... Remove this comment to see the full error message
  if (pannel.view_tabs_loaded) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'view_tabs_loaded' does not exist on type... Remove this comment to see the full error message
    pannel.view_tabs_loaded = [];
  }

  pannel.current_type = 'view';
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'ajax_view' does not exist on type 'Parti... Remove this comment to see the full error message
  pannel.view = result.ajax_view;

  window.pushParent(pannel);

  // @ts-expect-error ts-migrate(2322) FIXME: Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
  window.merchantos.page.show('view', { html: result.html });

  window.setViewTitle(pannel);
  window.autoLoadListings(pannel, pannel.id);

  window.initCustomFields(pannel.view);

  window.subscribeViewKeys(pannel.id);

  window.clearFieldChanges(pannel);

  window.setAutoFocus();

  window.refreshPageHeader(pannel);
  $(pannel).trigger('viewready');
  window.finishAjaxRequest(pannel, result);
};

window.cb_editfield = function cb_editfield(result, format) {
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'PanelId | undefined' is not assi... Remove this comment to see the full error message
  const pannel = window.getListingPannel(result.pannel_id);
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
  if (pannel && result.ajax_listing) pannel.listing = result.ajax_listing;

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'refresh' does not exist on type 'Partial... Remove this comment to see the full error message
  if (result.refresh && result.pannel_id) {
    window.pushListingRefresh(result.pannel_id);
  }
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'refresh_listing' does not exist on type ... Remove this comment to see the full error message
  if (result.refresh_listing && result.pannel_id) {
    window.pushQueueRequest(result.pannel_id, `RefreshListing('${result.pannel_id}');`);
  }

  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
  const field = window.xGetElementById(result.field_id);
  if (field) {
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'HTMLElement' is not assignable t... Remove this comment to see the full error message
    window.setFormFieldValue(field, result.value, format, result.pannel_id);
    if (result.refocus) {
      window.setFocus(field);
    }
  }
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'PanelId | undefined' is not assi... Remove this comment to see the full error message
  window.finishAjaxRequest(result.pannel_id, result);
};

window.cb_dolistingfunction = function cb_dolistingfunction(result) {
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'PanelId | undefined' is not assi... Remove this comment to see the full error message
  const pannel = window.getListingPannel(result.pannel_id);
  if (pannel && result.ajax_listing) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
    pannel.listing = result.ajax_listing;
  }

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'clean' does not exist on type 'Partial<{... Remove this comment to see the full error message
  if (result.clean) {
    window.clearFieldChanges(false);
  }
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'success' does not exist on type 'Partial... Remove this comment to see the full error message
  if (result.success) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'return_to_parent' does not exist on type... Remove this comment to see the full error message
    if (result.return_to_parent) {
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'PanelId | undefined' is not assi... Remove this comment to see the full error message
      window.pushQueueRequest(result.pannel_id, `returnToParent('${result.pannel_id}');`);
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'refresh' does not exist on type 'Partial... Remove this comment to see the full error message
    } else if (result.refresh) {
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'PanelId | undefined' is not assi... Remove this comment to see the full error message
      window.pushListingRefresh(result.pannel_id);
    }
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'remove_row' does not exist on type 'Part... Remove this comment to see the full error message
    if (result.remove_row) {
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'PanelId | undefined' is not assi... Remove this comment to see the full error message
      window.removeListingRecord(result.pannel_id, result.row_num);
    }
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'boolean | HTMLElement' is not as... Remove this comment to see the full error message
    window.listingSelectNone(pannel);
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'return_to_parent' does not exist on type... Remove this comment to see the full error message
  } else if (result.return_to_parent) {
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'PanelId | undefined' is not assi... Remove this comment to see the full error message
    window.pushQueueRequest(result.pannel_id, `returnToParent('${result.pannel_id}');`);
  }
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'PanelId | undefined' is not assi... Remove this comment to see the full error message
  window.finishAjaxRequest(result.pannel_id, result);
};

window.subscribeListingKeys = function subscribeListingKeys(pannel_id) {
  window.merchantos.keyboard.subscribe('Alt+f', () => window.RefreshListing(pannel_id));
  window.merchantos.keyboard.subscribe('Alt+r', () => window.RefreshListing(pannel_id));
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'PanelId' is not assignable to pa... Remove this comment to see the full error message
  window.merchantos.keyboard.subscribe('Alt+m', () => window.listingAdvancedSearch(pannel_id));
  window.merchantos.keyboard.subscribe('Alt+c', () => window.returnToParent(pannel_id));
  window.merchantos.keyboard.subscribe('Alt+pageup', () => window.pageGoTo('previous'));
  window.merchantos.keyboard.subscribe('Alt+pagedown', () => window.pageGoTo('next'));
  window.merchantos.keyboard.subscribe('Alt+home', () => window.pageGoTo('first'));
  window.merchantos.keyboard.subscribe('Alt+end', () => window.pageGoTo('last'));
};

window.pushListingRefresh = function pushListingRefresh(pannel_id) {
  const pannel = window.getRealPannel(pannel_id);
  if (!pannel) {
    window.pushQueueRequest(pannel_id, `RefreshListing('${pannel_id}');`);
    return;
  }

  if (pannel.current_type == 'listing') {
    window.pushQueueRequest(pannel.id, `RefreshListing('${pannel.id}');`);
    return;
  }

  window.pushQueueRequest(pannel.id, `openView('${pannel.id}');`);
};

window.getListingPannelFromContext = function getListingPannelFromContext(context) {
  const pannel = $(context).closest('.is_pannel')[0];
  return window.getListingPannelGeneric(pannel);
};

window.getListingPannel = function getListingPannel(pannel_id) {
  const pannel = window.xGetElementById(pannel_id);
  return window.getListingPannelGeneric(pannel);
};

window.getListingPannelGeneric = function getListingPannelGeneric(pannel) {
  if (!pannel) {
    return false;
  }

  if (!pannel.current_type) {
    if (pannel.listing) {
      pannel.current_type = 'listing';
    } else if (pannel.view) {
      pannel.current_type = 'view';
    } else {
      pannel.current_type = false;
    }
  }

  if (!pannel.listing) {
    pannel.listing = {};
    pannel.listing.draw_all = true;
    pannel.listing.draw_tab_only = false;
  }

  return pannel;
};

/**
 * Opens a listing page in pannel_id.
 * @param {String} pannel_id
 * @param {String} name
 * @param {String} init_search
 * @param {String} tab
 * @returns {$.Deferred}
 * @constructor
 */
window.OpenListing = function OpenListing(pannel_id, name, init_search, tab) {
  const pannel = window.xGetElementById(pannel_id);
  const promise = $.Deferred();

  if (!pannel) return promise.resolve().promise();

  if (window.isWorking(pannel)) return promise.resolve().promise();

  window.saveOnChanges(pannel).done(() => {
    // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'listing'.
    listing = {};
    // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'listing'.
    listing.draw_all = true;
    // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'listing'.
    listing.draw_tab_only = false;
    // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'listing'.
    listing.name = name;
    // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'listing'.
    listing.request = getContextRequest(pannel_id);
    // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'listing'.
    listing.saved_search = {};

    // @ts-expect-error ts-migrate(2339) FIXME: Property '__sort' does not exist on type 'object'.
    if (init_search.__sort) {
      // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'listing'.
      listing.sort = init_search.__sort;
    }
    // @ts-expect-error ts-migrate(2339) FIXME: Property '__sort_dir' does not exist on type 'obje... Remove this comment to see the full error message
    if (init_search.__sort_dir) {
      // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'listing'.
      listing.sort_dir = init_search.__sort_dir;
    }

    let search = {};
    /*
     * init_search can be of two forms:
     * [
     *  ["key","value"],
     *  ["key2","value2"]
     * ]
     * or
     * {
     *  "key":"value",
     *  "key2":"value2"
     * }
     *
     * We want to convert format 1 into form 2
     */
    if (Array.isArray(init_search)) {
      $.each(init_search, (i, v) => {
        if (typeof i === 'number' && (i % 1 === 0 || i === 0)) {
          // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
          search[v[0]] = v[1];
        } else {
          // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
          search[i] = v;
        }
      });
      // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'listing'.
      listing.saved_search = search;
    } else if ($.isPlainObject(init_search)) {
      // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'listing'.
      listing.saved_search = init_search;
      search = init_search;
    }

    window.setWorking(pannel);

    const content_map = {} as ContentMap;
    content_map.form_name = 'listing.refresh';
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'ajax_listing' does not exist on type 'Co... Remove this comment to see the full error message
    content_map.ajax_listing = window.toJsonString(listing);
    content_map.key_values = window.toJsonString(search);
    content_map.pannel_id = pannel.id;
    if (tab) {
      content_map.tab = tab;
    }

    window.doServerCall(content_map, window.cb_openlisting).always(() => promise.resolve());
  });

  return promise;
};

/**
 *
 * @param {Element} pannel_id
 * @returns {null|$.Deferred}
 * @constructor
 */
window.RefreshListing = function RefreshListing(pannel_id, refresh_inventory_count_filter) {
  const pannel = window.getListingPannel(pannel_id);

  if (!pannel) return;

  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'true | HTMLElement' is not assig... Remove this comment to see the full error message
  if (window.isWorking(pannel)) return;

  const deferred = $.Deferred();

  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'true | HTMLElement' is not assig... Remove this comment to see the full error message
  window.saveOnChanges(pannel).done(() => {
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'true | HTMLElement' is not assig... Remove this comment to see the full error message
    window.fillSavedListingSearch(pannel);

    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'true | HTMLElement' is not assig... Remove this comment to see the full error message
    window.setWorking(pannel);

    // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'work_pannel'.
    work_pannel = window.xGetElementById(`work_${pannel.id}`);
    // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'work_pannel'.
    if (!work_pannel) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
      pannel.listing.draw_all = true;
    }

    const content_map = {} as ContentMap;

    // CLD-4140 Reset the user settings for the search field in inventory count on new count
    if (refresh_inventory_count_filter) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
      pannel.listing.name = 'inventory_count.listings.inventory_count_items';
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'refresh_inventory_count_filter' does not... Remove this comment to see the full error message
      content_map.refresh_inventory_count_filter = true;
    }

    content_map.form_name = 'listing.refresh';
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'ajax_listing' does not exist on type 'Co... Remove this comment to see the full error message
    content_map.ajax_listing = window.toJsonString(pannel.listing);
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
    content_map.key_values = window.toJsonString(pannel.listing.saved_search);

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'id' does not exist on type 'true | HTMLE... Remove this comment to see the full error message
    content_map.pannel_id = pannel.id;
    window
      // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'cb_refresh'.
      .doServerCall(content_map, !refresh_inventory_count_filter && cb_refresh)
      .always(() => deferred.resolve());
  });

  return deferred;
};

window.PageControlListing = function PageControlListing(pannel) {
  if (!pannel) {
    return;
  }

  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  pannel.listing.draw_tab_only = true;
  window.RefreshListing(pannel);
};

window.openListingRowNum = function openListingRowNum(pannel_id, row_num) {
  const rec_num = window.getRecNum(pannel_id, row_num);
  window.openListingRecordNum(pannel_id, rec_num, row_num);
};

window.openListingRecordNum = function openListingRecordNum(pannel_id, rec_num, row_num) {
  const listing_pannel = window.getListingPannel(pannel_id);
  const view_pannel = window.getViewPannel('view');

  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  if (view_pannel.view.stored_listing) {
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    view_pannel.stored_listing = view_pannel.view.stored_listing;
  }

  if (!listing_pannel || !view_pannel) return;

  if (window.isWorking(view_pannel)) return;

  window.saveOnChanges(view_pannel).done(() => {
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    view_pannel.view.rec_num = rec_num;

    window.setWorking(view_pannel);

    const content_map = {} as ContentMap;

    // if we have a row_num then get the row value str
    let has_row_values = false;
    let row_values: any;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing_row_values' does not exist on ty... Remove this comment to see the full error message
    if (row_num !== undefined && listing_pannel.listing_row_values) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing_row_values' does not exist on ty... Remove this comment to see the full error message
      row_values = listing_pannel.listing_row_values[row_num];
      has_row_values = true;
    }

    // if we are getting this from a listing then store the listing info
    if (has_row_values) {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      view_pannel.view.count = listing_pannel.listing.count;

      // @ts-expect-error ts-migrate(2339) FIXME: Property 'new_stored_listing' does not exist on ty... Remove this comment to see the full error message
      view_pannel.new_stored_listing = listing_pannel.listing;
    } else {
      if (view_pannel.stored_listing) {
        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        view_pannel.view.count = view_pannel.stored_listing.count;
      }

      // @ts-expect-error ts-migrate(2339) FIXME: Property 'new_stored_listing' does not exist on ty... Remove this comment to see the full error message
      view_pannel.new_stored_listing = false;
    }

    content_map.form_name = 'listing.openviewrecord';
    content_map.ajax_view = window.toJsonString(view_pannel.view);
    if (has_row_values) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'row' does not exist on type 'ContentMap'... Remove this comment to see the full error message
      content_map.row = window.toJsonString(row_values);
    } else {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'ajax_listing' does not exist on type 'Co... Remove this comment to see the full error message
      content_map.ajax_listing = window.toJsonString(view_pannel.stored_listing);
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      content_map.key_values = window.toJsonString(view_pannel.stored_listing.saved_search);
    }
    content_map.pannel_id = 'view';
    window.doServerCall(content_map, window.cb_openviewrecord);
  });
};

window.openListingRecordView = function openListingRecordView(pannel_id, name, row_num, tab) {
  const pannel = window.getViewPannel('view');

  if (!pannel) {
    return;
  }

  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  if (pannel.view.name != name) {
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    pannel.view.tab = false;
  }
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  pannel.view.name = name;
  if (tab) {
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    pannel.view.tab = tab;
  }
  window.openListingRowNum(pannel_id, row_num);
};

window.listingSearch = function listingSearch(pannel_id) {
  const pannel = window.getListingPannel(pannel_id);

  if (!pannel) {
    return;
  }
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
  pannel.listing.user_search = true;
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
  pannel.listing.page = 1;

  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'true | HTMLElement' is not assig... Remove this comment to see the full error message
  window.refreshSavedListingSearch(pannel);

  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'true | HTMLElement' is not assig... Remove this comment to see the full error message
  const deferred = window.RefreshListing(pannel);

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'querySelector' does not exist on type 't... Remove this comment to see the full error message
  const button = pannel.querySelector('#searchButton');
  if (deferred && button) {
    // Track multiple clicks & visually disable button
    // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
    window.merchantos.sidebar.xhrStarted(pannel.listing.name, button, deferred);
  }
};

$(document).on('click', '.listing .navigate a', function onListingNavClick(event) {
  event.preventDefault();

  // Parse Href for action
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  const action = $(this)
    .attr('href')
    .replace('#', '');

  switch (action) {
    case 'page_size':
      window.listingUserPageSize(this);
      break;
    default:
      window.pageGoTo(this, action);
      break;
  }

  return false;
});

window.pageGoTo = function pageGoTo(context, page) {
  const pannel = window.getListingPannelFromContext(context);

  // eslint-disable-next-line default-case
  switch (page) {
    case 'first':
      page = '1';
      break;
    case 'previous':
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'boolean... Remove this comment to see the full error message
      page = parseInt(pannel.listing.page, 10) - 1;
      break;
    case 'next':
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'boolean... Remove this comment to see the full error message
      page = parseInt(pannel.listing.page, 10) + 1;
      break;
    case 'last':
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'boolean... Remove this comment to see the full error message
      page = parseInt(pannel.listing.page_count, 10);
      break;
    case 'record':
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | null' is not assignable... Remove this comment to see the full error message
      const record = parseInt(prompt('What record would you like to view?'), 10);
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'boolean... Remove this comment to see the full error message
      page = Math.ceil(record / pannel.listing.page_size);
      break;
  }

  // Validate pannel and page are supplied
  if (!pannel || !page) {
    return false;
  }

  // Set page equal to one if it's less than 1
  if (page < 1) {
    page = 1;
  }

  // Don't let user go past end of pages
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
  if (page > pannel.listing.page_count) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
    page = pannel.listing.page_count;
  }

  // If we're already on that page don't refresh listing
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
  if (pannel.listing.page == page) {
    return;
  }

  // Change pannel setting and re-render
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
  pannel.listing.page = page;
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'true | HTMLElement' is not assig... Remove this comment to see the full error message
  window.PageControlListing(pannel);
};

window.listingUserPageSize = function listingUserPageSize(context) {
  const pannel = window.getListingPannelFromContext(context);
  let promptText = 'How many results per page would you like to display?';
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'boolean... Remove this comment to see the full error message
  if (pannel.listing.max_size !== 5000) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'boolean... Remove this comment to see the full error message
    promptText += `\nLimit ${pannel.listing.max_size}`;
  }
  const size = prompt(promptText);
  if (size) {
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'boolean | HTMLElement' is not as... Remove this comment to see the full error message
    window.setPageSize(pannel, parseInt(size, 10));
  }
};

window.setPageSize = function setPageSize(pannel, size) {
  if (!pannel || isNaN(size)) {
    return;
  }

  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  if (size <= 0 || size > pannel.listing.max_size) {
    alert(`Page size not set. Invalid page size: ${size}`);
    return;
  }

  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  if (pannel.listing.page_size == size) {
    return;
  }

  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  pannel.listing.page_size = size;
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  pannel.listing.page = 1;

  window.PageControlListing(pannel);
};

$(document).on('change', 'select.pageNum', event => {
  const page = event.target[event.target.selectedIndex].value;
  window.pageGoTo(event.target, page);
});

// Function called when a page with a listing on it is reloaded via browser controls
window.listingReloaded = function listingReloaded(retry) {
  if (!retry) {
    retry = 0;
  }
  const pannel_id = $('#listing')[0];
  const pannel = window.getListingPannel(pannel_id);
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'boolean | HTMLElement' is not as... Remove this comment to see the full error message
  window.fillSavedListingSearch(pannel);
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'boolean... Remove this comment to see the full error message
  const listing = pannel.listing;
  if (!listing.page && retry < 40) {
    window.setTimeout(() => {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      retry += 1;
      listingReloaded(retry);
    }, 50);
  } else if (listing.page) {
    window.setPageSelector(listing);

    // Register customers is opened in a uniquely weird way
    // Set up breadcrumbs for this particular listing
    if (listing.name == 'customer.listings.register_customers') {
      window.merchantos.register.addRegisterParent();
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'boolean | HTMLElement' is not as... Remove this comment to see the full error message
      window.pushParent(pannel);

      window.refreshPageHeader('listing');
    }
  }
};

// Set the page selector that allows a user to jump to a range of rows
window.setPageSelector = function setPageSelector(listing) {
  const $select = $('select.pageNum');
  let firstPage: number;
  let lastPage: number;
  // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
  if (listing.page_count <= 20 || listing.page <= 10) {
    firstPage = 2;
    if (listing.page_count <= 20) {
      lastPage = listing.page_count - 1;
    } else {
      lastPage = 20;
    }
  } else {
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'number | null' is not assignable... Remove this comment to see the full error message
    firstPage = parseInt(listing.page, 10) - 9;
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'number | null' is not assignable... Remove this comment to see the full error message
    lastPage = parseInt(listing.page, 10) + 10;
  }
  $select.append('<option>...</option>');

  for (let i = firstPage; i <= lastPage; i++) {
    const firstRow = listing.page_size * (i - 1) + 1;
    let lastRow = listing.page_size * i;
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    if (lastRow >= listing.count) {
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'number | null' is not assignable to type 'nu... Remove this comment to see the full error message
      lastRow = listing.count;
    }
    let option: string;
    if (i == listing.page) {
      option = `<option selected value="${i}">`;
    } else {
      option = `<option value="${i}">`;
    }
    option += `${firstRow} - ${lastRow}`;
    option += '</option>';
    $select.append(option);
  }
  $select.append('<option value="record">Jump to #</option>');
};

$(document).on('click', '.is_pannel .listing th a.sort', function onClickListingPanel(event) {
  event.preventDefault();

  const searchParams = window.merchantos.utils.getQueryParams(this.href);
  const pannel = $(this).closest('.is_pannel')[0];

  const sort_by_field = searchParams.__sort;
  const sort_direction = searchParams.__sort_dir;

  if (sort_by_field == pannel.listing.sort && sort_direction == pannel.listing.sort_dir) {
    return;
  }

  pannel.listing.sort = sort_by_field;
  pannel.listing.sort_dir = sort_direction;
  pannel.listing.page = 1;

  // @TODO - Figure this out at some point. Why do we have sort and __sort?
  // pannel.listing.saved_search.__sort = sort_by_field;
  // pannel.listing.saved_search.__sort_dir = sort_direction;

  window.PageControlListing(pannel);

  // Triggers preventDefault on click/touch event
  return false;
});

window.listingEditField = function listingEditField(field_id, ids, pannel_id, format_type) {
  const field = window.xGetElementById(field_id);
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  const col = field.name;
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'HTMLElement | undefined' is not ... Remove this comment to see the full error message
  const value = window.getFormFieldValue(field);
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  field_id = field.id;

  const pannel = window.getListingPannel(pannel_id);
  if (!pannel) return;

  const content_map = {} as ContentMap;
  content_map.form_name = 'listing.editfield';
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'ajax_listing' does not exist on type 'Co... Remove this comment to see the full error message
  content_map.ajax_listing = window.toJsonString(pannel.listing);
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'col' does not exist on type 'ContentMap'... Remove this comment to see the full error message
  content_map.col = col;
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'ids' does not exist on type 'ContentMap'... Remove this comment to see the full error message
  content_map.ids = ids;
  // @ts-expect-error ts-migrate(2322) FIXME: Type 'string | { [key: string]: string; }' is not ... Remove this comment to see the full error message
  content_map.value = value;
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'field_id' does not exist on type 'Conten... Remove this comment to see the full error message
  content_map.field_id = field_id;
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'id' does not exist on type 'true | HTMLE... Remove this comment to see the full error message
  content_map.pannel_id = pannel.id;

  window.doServerCall(content_map, result => window.cb_editfield(result, format_type));
};

window.cb_update_serial = function cb_update_serial(result) {
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'PanelId | undefined' is not assi... Remove this comment to see the full error message
  const pannel = window.getListingPannel(result.pannel_id);
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
  if (pannel && result.ajax_listing) pannel.listing = result.ajax_listing;

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'refresh' does not exist on type 'Partial... Remove this comment to see the full error message
  if (result.refresh && result.pannel_id) {
    window.pushListingRefresh(result.pannel_id);
  }

  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'PanelId | undefined' is not assi... Remove this comment to see the full error message
  window.finishAjaxRequest(result.pannel_id, result);
};

// @ts-expect-error ts-migrate(2322) FIXME: Type '(pannel_id: any, transaction_line_id: any, c... Remove this comment to see the full error message
window.listingAssignItemSerial = function listingAssignItemSerial(
  pannel_id: any,
  transaction_line_id: any,
  customer_id: any,
  serialized_id: any
) {
  const pannel = window.getListingPannel(pannel_id);
  if (!pannel) return;

  const content_map = {} as ContentMap;
  content_map.form_name = 'serialized.assign_serial';
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'ajax_listing' does not exist on type 'Co... Remove this comment to see the full error message
  content_map.ajax_listing = window.toJsonString(pannel.listing);
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'id' does not exist on type 'true | HTMLE... Remove this comment to see the full error message
  content_map.pannel_id = pannel.id;
  content_map.transaction_line_id = transaction_line_id;
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'customer_id' does not exist on type 'Con... Remove this comment to see the full error message
  content_map.customer_id = customer_id;
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'serialized_id' does not exist on type 'C... Remove this comment to see the full error message
  content_map.serialized_id = serialized_id;
  window.doServerCall(content_map, window.cb_update_serial);
};

window.listingRemoveItemSerial = function listingRemoveItemSerial(pannel_id, serialized_id) {
  const pannel = window.getListingPannel(pannel_id);
  if (!pannel) return;

  const content_map = {} as ContentMap;
  content_map.form_name = 'serialized.delete_serial';
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'ajax_listing' does not exist on type 'Co... Remove this comment to see the full error message
  content_map.ajax_listing = window.toJsonString(pannel.listing);
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'id' does not exist on type 'true | HTMLE... Remove this comment to see the full error message
  content_map.pannel_id = pannel.id;
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'serialized_id' does not exist on type 'C... Remove this comment to see the full error message
  content_map.serialized_id = serialized_id;
  window.doServerCall(content_map, window.cb_update_serial);
};

window.doListingFunction = function doListingFunction(pannel_id, fnc, row_num) {
  const pannel = window.getListingPannel(pannel_id);

  if (!pannel) {
    return false;
  }
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'true | HTMLElement' is not assig... Remove this comment to see the full error message
  if (window.isWorking(pannel)) {
    return false;
  }

  if (window.merchantos.interrupt.isBlocked('listing.dofunction')) {
    window.merchantos.interrupt.push('listing.dofunction', () =>
      window.doListingFunction(pannel_id, fnc, row_num)
    );
    return false;
  }
  window.merchantos.interrupt.block('listing.dofunction');

  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'true | HTMLElement' is not assig... Remove this comment to see the full error message
  const selected_records = window.getSelectedRecords(pannel);

  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'true | HTMLElement' is not assig... Remove this comment to see the full error message
  window.fillSavedListingSearch(pannel);
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
  pannel.listing.row_num = row_num;
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
  pannel.listing.rec_num = window.getRecNum(pannel, row_num);

  let row_values = false;
  if (row_num >= 0) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing_row_values' does not exist on ty... Remove this comment to see the full error message
    row_values = pannel.listing_row_values[row_num];
  }

  const content_map = {} as ContentMap;
  content_map.form_name = 'listing.dofunction';
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'ajax_listing' does not exist on type 'Co... Remove this comment to see the full error message
  content_map.ajax_listing = window.toJsonString(pannel.listing);
  content_map.fnc = fnc;
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
  content_map.key_values = window.toJsonString(pannel.listing.saved_search);
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'row' does not exist on type 'ContentMap'... Remove this comment to see the full error message
  content_map.row = window.toJsonString(row_values);
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'selected_records' does not exist on type... Remove this comment to see the full error message
  content_map.selected_records = window.toJsonString(selected_records);
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'id' does not exist on type 'true | HTMLE... Remove this comment to see the full error message
  content_map.pannel_id = pannel.id;

  // If we error out during a listing function, we need to free this key
  $.when(window.doServerCall(content_map, window.cb_dolistingfunction)).then(() => {
    if (window.merchantos.interrupt.isBlocked('listing.dofunction')) {
      window.merchantos.interrupt.free('listing.dofunction');
    }
  });

  return true;
};

window.removeListingRecord = function removeListingRecord(pannel_id, row_num) {
  const pannel = window.getListingPannel(pannel_id);

  if (!pannel) return;

  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'true | HTMLElement' is not assig... Remove this comment to see the full error message
  window.addDeletedRow(pannel, row_num);

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'id' does not exist on type 'true | HTMLE... Remove this comment to see the full error message
  $(`#${pannel.id}_r_${row_num}`).hide();
};

window.clearSavedListingSearch = function clearSavedListingSearch(pannel_id) {
  const pannel = window.getListingPannel(pannel_id);

  if (!pannel) return;

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
  if (pannel.listing.saved_search) delete pannel.listing.saved_search;
};
window.fillSavedListingSearch = function fillSavedListingSearch(pannel_id) {
  const pannel = window.getListingPannel(pannel_id);

  if (!pannel) return;

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
  if (window.objectPropertyCount(pannel.listing.saved_search) === 0) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
    pannel.listing.saved_search = window.getFormValues(`${pannel.id}_search`);
  }
};
window.refreshSavedListingSearch = function refreshSavedListingSearch(pannel_id) {
  const pannel = window.getListingPannel(pannel_id);

  if (!pannel) return;

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'chart' does not exist on type 'true | HT... Remove this comment to see the full error message
  if (pannel.chart) {
    // we've changed the search so we need to reset the chart so we get all the data for it again
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'chart' does not exist on type 'true | HT... Remove this comment to see the full error message
    pannel.chart = null;
  }

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
  pannel.listing.saved_search = window.getFormValues(`${pannel.id}_search`);
};

window.getListingTab = function getListingTab(pannel_id, tab) {
  const pannel = window.getListingPannel(pannel_id);

  if (!pannel) return;

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
  pannel.listing.tab = tab;
  // pannel.listing.draw_tab_only = true;
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'id' does not exist on type 'true | HTMLE... Remove this comment to see the full error message
  window.RefreshListing(pannel.id);
};

window.selectListingTab = function selectListingTab(pannel_id, to_tab) {
  const pannel = window.getListingPannel(pannel_id);

  if (to_tab === 'cat_matches') {
    const searchParams = window.merchantos.utils.getQueryParams(window.location.search);
    const pageContext = searchParams.name;
    window.Analytics.track('Clicked Legacy Catalog Matches', { pageContext });
  }

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing_tabs_loaded' does not exist on t... Remove this comment to see the full error message
  if (!pannel.listing_tabs_loaded) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing_tabs_loaded' does not exist on t... Remove this comment to see the full error message
    pannel.listing_tabs_loaded = [];
  }
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing_tabs_loaded' does not exist on t... Remove this comment to see the full error message
  pannel.listing_tabs_loaded[pannel.listing.tab] = true;

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'boolean... Remove this comment to see the full error message
  const from_tab = pannel.listing.tab;

  if (to_tab == from_tab) return;

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'id' does not exist on type 'boolean | HT... Remove this comment to see the full error message
  const from_pannel = window.xGetElementById(`${pannel.id}_${from_tab}`);
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'id' does not exist on type 'boolean | HT... Remove this comment to see the full error message
  const from_select = window.xGetElementById(`${pannel.id}_${from_tab}_select`);

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'id' does not exist on type 'boolean | HT... Remove this comment to see the full error message
  const to_pannel = window.xGetElementById(`${pannel.id}_${to_tab}`);
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'id' does not exist on type 'boolean | HT... Remove this comment to see the full error message
  const to_select = window.xGetElementById(`${pannel.id}_${to_tab}_select`);

  if (from_pannel && from_select && to_pannel && to_select) {
    $(from_pannel).hide();
    $(from_select).removeClass('current_tab');

    if (!from_pannel.listing) from_pannel.listing = {};

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'page' does not exist on type 'Partial<{ ... Remove this comment to see the full error message
    from_pannel.listing.page = pannel.listing.page;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'page_count' does not exist on type 'Part... Remove this comment to see the full error message
    from_pannel.listing.page_count = pannel.listing.page_count;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'boolean... Remove this comment to see the full error message
    from_pannel.listing.sort = pannel.listing.sort;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'boolean... Remove this comment to see the full error message
    from_pannel.listing.sort_dir = pannel.listing.sort_dir;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing_row_values' does not exist on ty... Remove this comment to see the full error message
    from_pannel.listing_row_values = pannel.listing_row_values;

    try {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'boolean... Remove this comment to see the full error message
      delete pannel.listing.page;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'boolean... Remove this comment to see the full error message
      delete pannel.listing.page_count;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'boolean... Remove this comment to see the full error message
      delete pannel.listing.sort;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'boolean... Remove this comment to see the full error message
      delete pannel.listing.sort_dir;
      // eslint-disable-next-line no-empty
    } catch (e) {}

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing_tabs_loaded' does not exist on t... Remove this comment to see the full error message
    if (pannel.listing_tabs_loaded[to_tab]) {
      to_pannel.style.display = '';
      $(to_select).addClass('current_tab');

      if (to_pannel.listing) {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'page' does not exist on type 'Partial<{ ... Remove this comment to see the full error message
        if (to_pannel.listing.page) pannel.listing.page = to_pannel.listing.page;
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'page_count' does not exist on type 'Part... Remove this comment to see the full error message
        if (to_pannel.listing.page_count) pannel.listing.page_count = to_pannel.listing.page_count;
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'boolean... Remove this comment to see the full error message
        if (to_pannel.listing.sort) pannel.listing.sort = to_pannel.listing.sort;
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'boolean... Remove this comment to see the full error message
        if (to_pannel.listing.sort_dir) pannel.listing.sort_dir = to_pannel.listing.sort_dir;
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing_row_values' does not exist on ty... Remove this comment to see the full error message
        if (to_pannel.listing_row_values) pannel.listing_row_values = to_pannel.listing_row_values;
      }

      window.setAutoFocus(to_pannel);

      // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'boolean... Remove this comment to see the full error message
      pannel.listing.tab = to_tab;

      // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'boolean... Remove this comment to see the full error message
      window.storePrefOnServer(pannel.listing.name, 'current_tab', pannel.listing.tab, pannel.id);

      window.showNotifier('working', 'Working...');
    } else {
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'boolean | HTMLElement' is not as... Remove this comment to see the full error message
      window.getListingTab(pannel, to_tab);
    }
  }
};

window.addDeletedRow = function addDeletedRow(pannel_id, row_num) {
  const pannel = window.getListingPannel(pannel_id);
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'boolean... Remove this comment to see the full error message
  if (!Array.isArray(pannel.listing.deleted_rows)) pannel.listing.deleted_rows = [];
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'boolean... Remove this comment to see the full error message
  pannel.listing.deleted_rows.push(row_num);
};

window.getRowsDeletedBefore = function getRowsDeletedBefore(pannel_id, row_num) {
  const pannel = window.getListingPannel(pannel_id);
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'boolean... Remove this comment to see the full error message
  if (!pannel.listing.deleted_rows) return 0;
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'boolean... Remove this comment to see the full error message
  if (!Array.isArray(pannel.listing.deleted_rows)) return 0;

  let count = 0;
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'boolean... Remove this comment to see the full error message
  for (let i = 0; i < pannel.listing.deleted_rows.length; i++) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'boolean... Remove this comment to see the full error message
    if (pannel.listing.deleted_rows[i] < row_num) count++;
  }
  return count;
};

window.getRecNum = function getRecNum(pannel_id, row_num) {
  const pannel = window.getListingPannel(pannel_id);

  if (!pannel) return 0;

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
  if (!pannel.listing) return 0;

  if (row_num < 0) return row_num;

  // adjust the row num based on how many rows have been removed above
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'true | HTMLElement' is not assig... Remove this comment to see the full error message
  row_num -= window.getRowsDeletedBefore(pannel, row_num);

  return (
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
    row_num + 1 + (parseInt(pannel.listing.page, 10) - 1) * parseInt(pannel.listing.page_size, 10)
  );
};

window.getRowNum = function getRowNum(pannel_id, rec_num) {
  const pannel = window.getListingPannel(pannel_id);

  if (!pannel) return -1;

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
  if (!pannel.listing) return -1;

  if (rec_num < 0) return -1;

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
  const row_num = rec_num - 1 - (pannel.listing.page - 1) * pannel.listing.page_size;

  return row_num;
};

$(document).on('click', 'a.advanced_toggle', function onAdvancedToggleClick(e) {
  $(this)
    .toggleClass('inactive')
    .toggleClass('active');
  e.preventDefault();
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'JQuery<any>' is not assignable t... Remove this comment to see the full error message
  window.listingAdvancedSearch($(this));
});

window.listingAdvancedSearch = function listingAdvancedSearch(toggler) {
  const form = toggler.closest('form');
  // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
  const pannel = $(`#${form.data('pannel')}`)[0];
  // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
  const advanced = form.find('.advanced');

  // Does pannel support advanced search?
  if (advanced.length > 0) {
    // Is advanced visible?
    if (advanced.is(':visible')) {
      // Yes? Hide it.
      advanced.fadeOut(300);
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      pannel.listing.display_advanced = 0;

      // Change toggle icon as well
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'find' does not exist on type 'HTMLElemen... Remove this comment to see the full error message
      toggler.find('i').attr('class', 'icon-plus');
    } else {
      // No? Show it.
      advanced.fadeIn(300);
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      pannel.listing.display_advanced = 1;

      // Change toggle icon as well
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'find' does not exist on type 'HTMLElemen... Remove this comment to see the full error message
      toggler.find('i').attr('class', 'icon-minus-sign');
    }

    // Store on the server
    window.storePrefOnServer(
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      pannel.listing.name,
      'display_advanced',
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      pannel.listing.display_advanced,
      $(pannel).attr('id')
    );

    // @TODO - Not sure why we do this.
    // showNotifier("working","Working...");
  }
};

window.autoLoadListings = function autoLoadListings(p_pannel_id: any, parent_id: any) {
  const p_pannel = window.xGetElementById(p_pannel_id);
  if (!p_pannel) {
    return;
  }

  $.each($(p_pannel).find('.auto_load_listing'), (_index, listing) => {
    const name = listing.name;
    const id = window.getFormFieldValue(listing);
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | { [key: string]: string... Remove this comment to see the full error message
    const pannel = window.getListingPannel(id);

    if (!pannel) {
      return false;
    }

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
    pannel.listing.name = name;

    if (parent_id) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'parent_id' does not exist on type 'true ... Remove this comment to see the full error message
      pannel.parent_id = parent_id;
    }

    // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
    const setups = $(pannel).find(`.${id}_setup`);

    if (setups.length <= 0) {
      window.pushQueueRequest(p_pannel, `RefreshListing('${id}');`);
      return true;
    }

    $.each(setups, (_index, setup) => {
      const value = window.getFormFieldValue(setup);
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
      pannel.listing[setup.name] = value;
    });

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
    if (pannel.listing.saved_search) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
      delete pannel.listing.saved_search;
    }

    window.pushQueueRequest(p_pannel, `RefreshListing('${id}');`);
  });
};

$(document).on('change', 'input[type="checkbox"].toggle_all', function onCheckboxChange(event) {
  event.preventDefault();
  window.listingToggleAll(this);
});

window.listingToggleAll = function listingToggleAll(control) {
  const referenced_pannel = $(control).data('pannel');
  const checkboxes = $(`input.${referenced_pannel}_rec_sel`);

  if ($(control).is(':checked')) {
    checkboxes.prop('checked', true);
  } else {
    checkboxes.prop('checked', false);
  }
};

window.listingSelectNone = function listingSelectNone(pannel_id) {
  const pannel = window.getListingPannel(pannel_id);
  if (!pannel) return;

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'id' does not exist on type 'true | HTMLE... Remove this comment to see the full error message
  const sel_class = `${pannel.id}_rec_sel`;

  const sels = window.custGetElementsByClassName(sel_class);
  for (let i = 0; i < sels.length; i++) {
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 4 arguments, but got 2.
    window.setFormFieldValue(sels[i], 'off');
  }
};

// @ts-expect-error ts-migrate(2322) FIXME: Type '(pannel_id: PanelId) => (string | undefined)... Remove this comment to see the full error message
window.getSelectedRecords = function getSelectedRecords(pannel_id) {
  const pannel = window.getListingPannel(pannel_id);
  if (!pannel) return [];

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'id' does not exist on type 'true | HTMLE... Remove this comment to see the full error message
  const sel_class = `${pannel.id}_rec_sel`;

  const selected_records = [];

  const sels = window.custGetElementsByClassName(sel_class);
  for (let i = 0; i < sels.length; i++) {
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'HTMLElement' is not assignable t... Remove this comment to see the full error message
    // eslint-disable-next-line no-continue
    if (window.getFormFieldValue(sels[i]) !== 'on') continue;
    if (sels[i].name) selected_records.push(sels[i].name);
  }
  return selected_records;
};

window.drillIntoListing = function drillIntoListing(pannel_id, listing_name, row_num) {
  const pannel = window.getListingPannel(pannel_id);
  if (!pannel) return;

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
  if (!pannel.listing.saved_search) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'id' does not exist on type 'true | HTMLE... Remove this comment to see the full error message
    window.refreshSavedListingSearch(pannel.id);
  }
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
  const search = pannel.listing.saved_search;

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing_row_values' does not exist on ty... Remove this comment to see the full error message
  if (row_num !== undefined && pannel.listing_row_values) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing_row_values' does not exist on ty... Remove this comment to see the full error message
    // eslint-disable-next-line no-return-assign
    $.each(pannel.listing_row_values[row_num], (key, value) => (search[key] = value));
  }

  // @ts-expect-error ts-migrate(7034) FIXME: Variable 'init_search' implicitly has type 'any[]'... Remove this comment to see the full error message
  const init_search = [];
  $.each(search, (key, value) => init_search.push([key, value]));

  // @ts-expect-error ts-migrate(7005) FIXME: Variable 'init_search' implicitly has an 'any[]' t... Remove this comment to see the full error message
  window.OpenListing(window.getRealPannel(pannel_id), listing_name, init_search);
};
